import React from "react";
import { useTranslation } from "react-i18next";
import { WrongInvoiceApi } from "../../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	wrongInvoices: WrongInvoiceApi[];
}

const AdminToolsWrongInvoicesTable = ({ wrongInvoices }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<table className="table w-100">
			<thead>
				<tr>
					<td>#</td>
					<td>{t("modules.tool.field.proforma_nr.title")}</td>
					<td>{t("modules.tool.field.invoice_nr.title")}</td>
					<td>{t("lib:common.word.status")}</td>
					<td>{t("modules.tool.field.price.title")}</td>
					<td>Company id</td>
					<td>Company name</td>
					<td>Invoice company name</td>
					<td>Chargebee company name</td>
				</tr>
			</thead>
			{wrongInvoices.map((wrongInvoice, index) => {
				return (
					<tr key={index}>
						<td>{index}</td>
						<td>{wrongInvoice.number}</td>
						<td>{wrongInvoice.invoice_number}</td>
						<td>{wrongInvoice.status}</td>
						<td>{wrongInvoice.amount}</td>
						<td>{wrongInvoice.company_id}</td>
						<td>{wrongInvoice.company_name}</td>
						<td>{wrongInvoice.chargebee_invoice_name}</td>
						<td>{wrongInvoice.chargebee_company_name}</td>
					</tr>
				);
			})}
		</table>
	);
};

export default AdminToolsWrongInvoicesTable;
